import { render } from "./ProfessionalLicensesCard.vue?vue&type=template&id=276e7ef5"
import script from "./ProfessionalLicensesCard.vue?vue&type=script&lang=js"
export * from "./ProfessionalLicensesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__